import { IcdCorporationManager, IcdCorporationManagerRM } from "@herbjoy/apex-api-models";
import { IHttpService } from "angular";

export class NationalConsultantService {
    constructor(private $http: IHttpService, private apexApiUrl: string) {
        'ngInject';
    }

    retrieveNationalConsultants() {
        return this.$http<IcdCorporationManagerRM[]>({
            method: "GET",
            url: this.apexApiUrl + "national-consultants"
        })
            .then(function (response) {
                return response.data;
            });
    }

    retrieveNationalConsultant(nationalConsultantID: number) {
        return this.$http<IcdCorporationManagerRM>({
            method: "GET",
            url: this.apexApiUrl + "national-consultants/" + nationalConsultantID
        })
            .then(function (response) {
                return response.data;
            });
    }

    saveNationalConsultant(nationalConsultant: IcdCorporationManager) {
        if (nationalConsultant.Id) {
            return this.$http<IcdCorporationManagerRM>({
                method: "PUT",
                url: this.apexApiUrl + "national-consultants/" + nationalConsultant.Id,
                data: JSON.stringify(nationalConsultant),
                headers: { "Content-Type": "application/json" }
            })
                .then(function (response) {
                    return nationalConsultant;
                });
        } else {
            return this.$http<IcdCorporationManagerRM>({
                method: "POST",
                url: this.apexApiUrl + "national-consultants",
                data: JSON.stringify(nationalConsultant),
                headers: { "Content-Type": "application/json" }
            })
                .then(function (response) {
                    return response.data;
                });
        }
    }

    deleteNationalConsultant(nationalConsultantID: number) {
        return this.$http({
            method: "DELETE",
            url: this.apexApiUrl + "national-consultants/" + nationalConsultantID,
            headers: {
                "Content-Type": "application/json"
            },
            data: {}
        });
    }
}
